import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const SingleAction = React.forwardRef(
  (
    {
      children,
      className,
      onClick,
      iconName,
      iconWidth = '16',
      iconHeight = '16',
      ...rest
    },
    ref,
  ) => (
    <ButtonWithIcon
      role="menuitem"
      className={className}
      onClick={onClick}
      containerClassName="text-16"
      ref={ref}
      isNaked
      iconOrientation="left"
      icon={iconName}
      isLeftOrientated
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      {...rest}
    >
      {children}
    </ButtonWithIcon>
  ),
);

SingleAction.defaultProps = {
  iconName: PropTypes.string.isRequired,
};

export default SingleAction;
